export const USER_AUTHENTICATED = 'events/USER_AUTHENTICATED';

/**
 * @return {{type: string}}
 */
export const userAuthenticated = () => ({ type: USER_AUTHENTICATED });
